import { VaultFolder } from './../dto/VaultFolder'  
import { VaultType } from './../dto/VaultType'
export class DataService {
  
    public static async GetCommittees(sessionId: number, vaultType: VaultType): Promise<VaultFolder> {

        return new Promise<VaultFolder>((resolve, reject) => {
            fetch(`/api/Committee/All?sessionId=${sessionId}&vaultType=${vaultType}`  , {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Error loading api');
                    }

                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                });
        });

    }
    public static async GetMeetings(committeeId: number): Promise<VaultFolder> {

        return new Promise<VaultFolder>((resolve, reject) => {
            fetch(`/api/Committee/Meetings?committeeId=${committeeId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Error loading api');
                    }

                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                });
        });

    }
}
